import React from 'react';

interface IProps {
  size?: string
}

const ClipboardCloseIcon: React.FC<IProps> = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" className={`w-[${size}px] h-[${size}px]`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M13.5339 3.0415H6.46719C4.40885 3.0415 2.74219 4.7165 2.74219 6.7665V14.6082C2.74219 16.6582 4.41719 18.3332 6.46719 18.3332H13.5255C15.5839 18.3332 17.2505 16.6582 17.2505 14.6082V6.7665C17.2589 4.70817 15.5839 3.0415 13.5339 3.0415Z"
      fill="#12B76A"
    />
    <path
      d="M11.9585 1.6665H8.0418C7.17513 1.6665 6.4668 2.3665 6.4668 3.23317V4.0165C6.4668 4.88317 7.1668 5.58317 8.03346 5.58317H11.9585C12.8251 5.58317 13.5251 4.88317 13.5251 4.0165V3.23317C13.5335 2.3665 12.8251 1.6665 11.9585 1.6665Z"
      fill="#12B76A"
    />
    <path
      d="M12.1089 13.0169L10.9005 11.8086L12.0672 10.6419C12.3089 10.4002 12.3089 10.0002 12.0672 9.75856C11.8255 9.51689 11.4255 9.51689 11.1839 9.75856L10.0172 10.9252L8.80885 9.71689C8.56719 9.47523 8.16719 9.47523 7.92552 9.71689C7.68385 9.95856 7.68385 10.3586 7.92552 10.6002L9.13385 11.8086L7.89219 13.0502C7.65052 13.2919 7.65052 13.6919 7.89219 13.9336C8.01719 14.0586 8.17552 14.1169 8.33385 14.1169C8.49219 14.1169 8.65052 14.0586 8.77552 13.9336L10.0172 12.6919L11.2255 13.9002C11.3505 14.0252 11.5089 14.0836 11.6672 14.0836C11.8255 14.0836 11.9839 14.0252 12.1089 13.9002C12.3505 13.6586 12.3505 13.2669 12.1089 13.0169Z"
      fill="#12B76A"
    />
  </svg>
);

export default ClipboardCloseIcon;
